/* eslint-disable no-await-in-loop */
import React, { useState, useEffect } from 'react';
import { connectSearchBox } from 'react-instantsearch-dom';
import { Form, Input } from './search-css';

export default connectSearchBox(({ refine, header, placeholders, ...rest }) => {
  const [placeholder, setPlaceholder] = useState();
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    // const words = ['Logo', 'Templates'];
    const typeWord = async (word) => {
      const chars = word.split('');
      let index = 0;
      while (index <= chars.length) {
        await sleep(100);
        setPlaceholder(chars.slice(0, index).join(''));
        index += 1;
      }
    };

    const cycleWords = async (words) => {
      for (let x = 0; x < words.length; x += 1) {
        await typeWord(words[x]);
        await sleep(1500);
        if (x === words.length - 1) x = -1;
      }
    };
    if (placeholders && placeholders.length) cycleWords(placeholders);
  }, []);

  return (
    <Form header={header}>
      <Input
        type="text"
        placeholder={placeholder}
        aria-label="Search"
        onChange={(e) => refine(e.target.value)}
        header={header}
        {...rest}
      />
      {/* <SearchIcon /> */}
    </Form>
  );
});
